/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_ActiveInputs */

const vi_customer_active = /** @type {(inputs: Customer_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoạt động`)
};

/**

* @param {Customer_ActiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_active = /** @type {((inputs?: Customer_ActiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_ActiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_active(inputs)
});